module.exports = {
	"OceanDragon": {
		"title": "Cookie Run: OvenBreak",
		"description": "Use this link to receive a Legendary Pet & Crystals!",
		"gift": "invites you to play<br />Cookie Run: OvenBreak for a reward!",
		"gift_no_name": "You have been invited to play<br />Cookie Run: OvenBreak for a reward!",
		"how_to_get_reward": "How to Get the Reward",
		"install_cro": "Install Cookie Run: OvenBreak",
		"claim_reward": "Complete the mission above<br />and tap on the \"Claim Reward\" button!",
		"rewards": "Reward: 1,000 Crystals + Ocean Dragon",
		"mission": "<strong>MISSION!</strong> Reach Stage 1-5 in Breakout Episode 1!",
		"condition": "Only new & returning players can receive the reward.",
		"new_player": "* New player? A player who started playing during the event period.",
		"old_player": "* Returning player? A player who has returned to<br />Cookie Run: OvenBreak after not playing for 30 days or more."
	},
	"2ndAnniversary": {
		"title": "Cookie Run: OvenBreak",
		"description": "Use this link to receive a Legendary Pet & Crystals!",
		"gift": "invites you to play<br />Cookie Run: OvenBreak for a reward!",
		"gift_no_name": "You have been invited to play<br />Cookie Run: OvenBreak for a reward!",
		"how_to_get_reward": "How to Get the Reward",
		"install_cro": "Install Cookie Run: OvenBreak",
		"claim_reward": "Complete the mission above<br />and tap on the \"Claim Reward\" button!",
		"rewards": "Reward: Crystals x2,222 + Ocean Dragon",
		"mission": "<strong>MISSION!</strong> Reach Stage 1-5 in Breakout Episode 1!",
		"condition": "Only new & returning players can receive the reward.",
		"new_player": "* New player? A player who started playing during the event period.",
		"old_player": "* Returning player? A player who has returned to<br />Cookie Run: OvenBreak after not playing for 30 days or more."
	},
	"MoonLight": {
		"title": "Cookie Run: OvenBreak",
		"description": "Use the link to receive a Legendary Cookie & Crystals!",
		"gift": "invites you to play<br />Cookie Run: OvenBreak for a reward!",
		"gift_no_name": "You have been invited to play<br />Cookie Run: OvenBreak for a reward!",
		"how_to_get_reward": "How to Get the Reward",
		"install_cro": "Install Cookie Run: OvenBreak",
		"claim_reward": "Complete the mission above<br />and tap on the \"Claim Reward\" button!",
		"rewards": "* Reward: 1,000 Crystals + Moonlight Cookie",
		"mission": "<strong>MISSION!</strong> Reach Stage 1-5 in Breakout Episode 1!",
		"condition": "Only new & returning players can receive the reward.",
		"new_player": "* New player? A player who started playing during the event period.",
		"old_player": "* Returning player? A player who has returned to<br />Cookie Run: OvenBreak after not playing for 30 days or more."
	},
	"FireSpirit": {
		"title": "Cookie Run: OvenBreak",
		"description": "Use the link to receive a Legendary Cookie & Crystals!",
		"gift": "invites you to play<br />Cookie Run: OvenBreak for a reward!",
		"gift_no_name": "You have been invited to play<br />Cookie Run: OvenBreak for a reward!",
		"how_to_get_reward": "How to Get the Reward",
		"install_cro": "Install Cookie Run: OvenBreak",
		"claim_reward": "Complete the mission above<br />and tap on the \"Claim Reward\" button!",
		"rewards": "* Reward: 1,000 Crystals + Fire Spirit Cookie",
		"mission": "<strong>MISSION!</strong> Enter Trophy Race!",
		"condition": "Only new & returning players can receive the reward.",
		"new_player": "* New player? A player who started playing during the event period.",
		"old_player": "* Returning player? A player who has returned to<br />Cookie Run: OvenBreak after not playing for 30 days or more."
	},
	"RainbowCube": {
		"title": "Cookie Run: OvenBreak",
		"description": "Use the link to get Rainbow Cubes & Crystals!",
		"gift": "invites you to play<br />Cookie Run: OvenBreak for a reward!",
		"gift_no_name": "You have been invited to play<br />Cookie Run: OvenBreak for a reward!",
		"how_to_get_reward": "How to Get the Reward",
		"install_cro": "Install Cookie Run: OvenBreak",
		"claim_reward": "Complete the mission above<br />and tap on the \"Claim Reward\" button!",
		"rewards": "* GIFT: 3,000 Crystals + 1,000 Rainbow Cubes",
		"mission": "<strong>MISSION!</strong> Enter Trophy Race!",
		"condition": "Only new & returning players can receive the reward.",
		"new_player": "* New player? A player who started playing during the event period.",
		"old_player": "* Returning player? A player who has returned to<br />Cookie Run: OvenBreak after not playing for 30 days or more."
	},
	"JellySkin": {
		"title": "Cookie Run: OvenBreak",
		"description": "Use the link to get Rainbow Cubes & Crystals!",
		"gift": "invites you to play<br />Cookie Run: OvenBreak for a reward!",
		"gift_no_name": "Rainbow Cubes & Crystals for New and Returning Users!",
		"how_to_get_reward": "How to Get the Reward",
		"install_cro": "Install Cookie Run: OvenBreak",
		"claim_reward": "Complete the mission above<br />and tap on the \"Claim Reward\" button!",
		"rewards": "* GIFT: 3,000 Crystals + 1,000 Rainbow Cubes",
		"mission": "<strong>MISSION!</strong> Enter Trophy Race!",
		"condition": "Only new & returning players can receive the reward.",
		"new_player": "* New player? A player who started playing during the event period.",
		"old_player": "* Returning player? A player who has returned to<br />Cookie Run: OvenBreak after not playing for 30 days or more."
	},
	"Yeti": {
		"title": "Cookie Run: OvenBreak",
		"description": "Use the link to get Crystals and a Legendary Pet!",
		"gift": "invites you to play<br />Cookie Run: OvenBreak for a reward!",
		"gift_no_name": "A gift of Crystals and a Legendary Pet for all New & Returning Players!",
		"how_to_get_reward": "How to Get the Reward",
		"install_cro": "Install Cookie Run: OvenBreak",
		"claim_reward": "Complete the mission above<br />and tap on the \"Claim Reward\" button!",
		"rewards": "* GIFT: 1,000 Crystals + Thundersnow Yeti",
		"mission": "<strong>MISSION!</strong> Enter Trophy Race!",
		"condition": "Only new & returning players can receive the reward.",
		"new_player": "* New player? A player who started playing during the event period.",
		"old_player": "* Returning player? A player who has returned to<br />Cookie Run: OvenBreak after not playing for 30 days or more."
	},
	"DreamCatcher": {
		"title": "Cookie Run: OvenBreak",
		"description": "Use the link to get Crystals and a Legendary Pet!",
		"gift": "invites you to play<br />Cookie Run: OvenBreak for a reward!",
		"gift_no_name": "A gift of Crystals and a Legendary Pet for all New & Returning Players!",
		"how_to_get_reward": "How to Get the Reward",
		"install_cro": "Install Cookie Run: OvenBreak",
		"claim_reward": "Complete the mission above<br />and tap on the \"Claim Reward\" button!",
		"rewards": "* Reward: 1,000 Crystals + Dreamcatcher",
		"mission": "<strong>MISSION!</strong> Enter Trophy Race!",
		"condition": "Only new & returning players can receive the reward.",
		"new_player": "* New player? A player who started playing during the event period.",
		"old_player": "* Returning player? A player who has returned to<br />Cookie Run: OvenBreak after not playing for 30 days or more."
	},
	"WaveDrop": {
		"title": "Cookie Run: OvenBreak",
		"description": "Use the link to get Crystals and a Legendary Pet!",
		"gift": "invites you to play<br />Cookie Run: OvenBreak for a reward!",
		"gift_no_name": "A gift of Crystals and a Legendary Pet for all New & Returning Players!",
		"how_to_get_reward": "How to Get the Reward",
		"install_cro": "Install Cookie Run: OvenBreak",
		"claim_reward": "Complete the mission above<br />and tap on the \"Claim Reward\" button!",
		"rewards": "* Reward: 1,000 Crystals + WaveDrop",
		"mission": "<strong>MISSION!</strong> Enter Trophy Race!",
		"condition": "Only new & returning players can receive the reward.",
		"new_player": "* New player? A player who started playing during the event period.",
		"old_player": "* Returning player? A player who has returned to<br />Cookie Run: OvenBreak after not playing for 30 days or more."
	},
	"JellySkin02": {
		"title": "Cookie Run: OvenBreak",
		"description": "Use the link to get Crystals and meet Space Doughnut!",
		"gift": "invites you to play<br />Cookie Run: OvenBreak for a reward!",
		"gift_no_name": "All New & Returning Players will receive Crystals,<br />Space Doughnut, and Space Mini Ball!",
		"how_to_get_reward": "How to Get the Reward",
		"install_cro": "Install Cookie Run: OvenBreak",
		"claim_reward": "Complete the mission above<br />and tap on the \"Claim Reward\" button!",
		"rewards": "* Gift: Crystals x1,000, Space Doughnut & Space Mini Ball x20 each",
		"mission": "<strong>MISSION!</strong> Enter Trophy Race!",
		"condition": "Only new & returning players can receive the reward.",
		"new_player": "* New player? A player who started playing during the event period.",
		"old_player": "* Returning player? A player who has returned to<br />Cookie Run: OvenBreak after not playing for 30 days or more."
	}
};